import client from './client';

export default {
  sendRecommendOfficeEmail(params) {
    return client.post('/managers/recommend')
      .send(params)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/recommendOfficeAPI.js